<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
      <v-tabs slider-color="grey">
        <!--<v-tab class="tab" :key="1" ripple>Store Info</v-tab>-->
        <v-tab class="tab" :key="1" ripple>Client Info</v-tab>
        <v-tab class="tab" v-for="(item, i) in processData.tabs" :key="i+2" ripple>{{ processData.tabs[i].name }}</v-tab>
        <!--<v-tab class="tab" :key="3" ripple>Job Info</v-tab>
        <v-tab class="tab" :key="4" ripple>Info Check</v-tab>
        <v-tab class="tab" :key="5" ripple>Plan Contacts</v-tab>
        <v-tab class="tab" :key="6" ripple>Roof Info 1</v-tab>
        <v-tab class="tab" :key="7" ripple>Roof Info 2</v-tab>
        <v-tab class="tab" :key="8" ripple>Design Assistance</v-tab>-->
        <!--<v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg6>
                <label class="blackLabel">Branch</label>
                <v-select :items="branchList" v-model="globalModalParams.surveyData.store_info_branch" :rules="rules" placeholder="Store Name" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">KAM</label>
                <v-select :items="kamUsers" v-model="globalModalParams.surveyData.store_info_kam" :rules="rules" placeholder="KAM User" class="dropdown" item-value="userid" item-text="fullname" solo outline></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>-->
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1" v-if="globalModalParams.surveyData != undefined">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg3>
                <label class="blackLabel">Name</label>
                <v-text-field placeholder="Co Name" v-model="globalModalParams.surveyData.client_info_co_name" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Contact Person</label>
                <v-text-field placeholder="Contact Person" v-model="globalModalParams.surveyData.client_info_contact" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Contact Person Cell</label>
                <v-text-field placeholder="Contact Person Cell" v-model="globalModalParams.surveyData.client_info_cell" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Acc No</label>
                <v-text-field placeholder="Acc No" v-model="globalModalParams.surveyData.client_info_acc_no" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Tel</label>
                <v-text-field placeholder="Tel" v-model="globalModalParams.surveyData.client_info_tel" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <!--<v-flex lg3>
                <label class="blackLabel">Fax</label>
                <v-text-field placeholder="Fax" v-model="globalModalParams.surveyData.client_info_fax" :rules="rules" single-line solo></v-text-field>
              </v-flex>-->
              <v-flex lg3>
                <label class="blackLabel">Email</label>
                <v-text-field placeholder="Email" v-model="globalModalParams.surveyData.client_info_email" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Project</label>
                <v-select :items="projectList" v-model="globalModalParams.surveyData.project"  placeholder="Project" class="dropdown" item-value="id" item-text="name" solo ></v-select>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Company</label>
                <v-text-field placeholder="Company" v-model="globalModalParams.surveyData.survey_company" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Street No. and Name</label>
                <v-text-field placeholder="Street No. and Name" v-model="globalModalParams.surveyData.customer_address" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Complex Name and No.</label>
                <v-text-field placeholder="Complex Name and No." v-model="globalModalParams.surveyData.customer_address_two" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Suburb</label>
                <v-text-field placeholder="Suburb" v-model="globalModalParams.surveyData.customer_suburb" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Town</label>
                <v-text-field placeholder="Town" v-model="globalModalParams.surveyData.customer_town" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Province</label>
                <v-text-field placeholder="Province" v-model="globalModalParams.surveyData.customer_province" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Postal Code</label>
                <v-text-field placeholder="Postal Code" v-model="globalModalParams.surveyData.customer_postal_code" single-line solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" v-for="(item, i) in processData.tabs" :key="i+2">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex v-bind:class="fncCheckClass(processData.tabs[i].form[n].type)" lg3 v-for="(item, n) in processData.tabs[i].form">
                <h4 style="display: block; clear: both;" v-if="processData.tabs[i].form[n].type == 'header'">{{ processData.tabs[i].form[n].label }}</h4>
                <label class="blackLabel" v-if="processData.tabs[i].form[n].type != 'header'"><span v-if="processData.tabs[i].form[n].required == 'true'">*&nbsp;</span>{{ processData.tabs[i].form[n].label }}</label>
                <v-text-field v-if="processData.tabs[i].form[n].type == 'input'" :placeholder="processData.tabs[i].form[n].label" @input="fncCheckValid" v-model="processData.tabs[i].form[n].value" :rules="rules" single-line solo></v-text-field>
                <v-select v-if="processData.tabs[i].form[n].type == 'select'" @input="fncCheckValid" :items="fncGetValues(processData.tabs[i].form[n].values)" v-model="processData.tabs[i].form[n].value" :placeholder="processData.tabs[i].form[n].label" class="dropdown" solo outline></v-select>
                <v-switch v-if="processData.tabs[i].form[n].type == 'yesno'" @change="fncCheckValid" :label="processData.tabs[i].form[n].label" v-model="processData.tabs[i].form[n].value"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <!--<v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg3>
                <label class="blackLabel">Project Name</label>
                <v-text-field placeholder="Project Name" v-model="globalModalParams.surveyData.job_info_project_name" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Number of units</label>
                <v-text-field placeholder="Number of units" v-model="globalModalParams.surveyData.job_info_number_of_units" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Building Type</label>
                <v-select :items="buildingTypes" v-model="globalModalParams.surveyData.job_info_building_type" :rules="rules" placeholder="Building Type" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Building Stage</label>
                <v-select :items="buildingStages" v-model="globalModalParams.surveyData.job_info_building_stage" :rules="rules" placeholder="Building Stage" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg12 class="formDivider"></v-flex>
              <v-flex lg12>
                <h3>SITE</h3>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">ERF Number</label>
                <v-text-field placeholder="ERF Number" v-model="globalModalParams.surveyData.site_erf_number" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Area</label>
                <v-text-field placeholder="Area" v-model="globalModalParams.surveyData.site_area" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">City</label>
                <v-text-field placeholder="City" v-model="globalModalParams.surveyData.site_city" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Site Conditions</label>
                <v-text-field placeholder="Site Conditions" v-model="globalModalParams.surveyData.site_site_conditions" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Distance from store</label>
                <v-text-field placeholder="Distance from branch" v-model="globalModalParams.surveyData.site_distance_from_branch" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">GPS Co-ords - Lat</label>
                <v-text-field placeholder="GPS Co-ords - Lat" v-model="globalModalParams.surveyData.site_gps_coords_lat" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">GPS Co-ords - Long</label>
                <v-text-field placeholder="GPS Co-ords - Long" v-model="globalModalParams.surveyData.site_gps_coords_long" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Street Address</label>
                <v-text-field placeholder="Street Address" v-model="globalModalParams.surveyData.site_street_address" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Estate / Complex Name</label>
                <v-text-field placeholder="Estate / Complex Name" v-model="globalModalParams.surveyData.site_complex_name" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Access</label>
                <v-select :items="access" placeholder="Access" v-model="globalModalParams.surveyData.site_access" class="dropdown" :rules="rules" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Special Instructions</label>
                <v-text-field placeholder="Special Instruction" v-model="globalModalParams.surveyData.site_special_instructions" :rules="rules" single-line solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg3>
                <label class="blackLabel">Are all the dimensions indicated?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_dimensions_indicated"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Are you able to get an electronic copy of the drawings?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_electronic_copy"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Are dimensions and notes clearly legible?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_notes_elegible"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Where specifications are referred to you you have these?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_have_specifications"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Do you have the drawing number, revision and revision date?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_have_revisions"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Where it says "to match existing", etc. have you recorded what is existing?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_match_existing"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Where the details are referred to do you have those details ( E.g. Engineer )?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_have_details"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Any unusual loads on the roof? ( Things hanging off the roof? E.g. Extractor Hoods )</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_unusual_load"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Any unusual details? (E.g. Rooflights)</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_unusual_details"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Customer special needs or preferrence?</label>
                <v-switch v-model="globalModalParams.surveyData.info_check_special_needs"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg12>
                <h4>ARCHITECT</h4>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Contact Person</label>
                <v-text-field placeholder="Contact Person" v-model="globalModalParams.surveyData.plans_architect_contact_person" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Tel</label>
                <v-text-field placeholder="Tel" v-model="globalModalParams.surveyData.plans_architect_tel" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Cell</label>
                <v-text-field placeholder="Cell" v-model="globalModalParams.surveyData.plans_architect_cell" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Email</label>
                <v-text-field placeholder="Email" v-model="globalModalParams.surveyData.plans_architect_email" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg12 class="formDivider"></v-flex>
              <v-flex lg12>
                <h4>ENGINEER</h4>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Contact Person</label>
                <v-text-field placeholder="Contact Person" v-model="globalModalParams.surveyData.plans_engineer_contact_person" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Tel</label>
                <v-text-field placeholder="Tel" v-model="globalModalParams.surveyData.plans_engineer_tel" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Cell</label>
                <v-text-field placeholder="Cell" v-model="globalModalParams.surveyData.plans_engineer_cell" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Email</label>
                <v-text-field placeholder="Email" v-model="globalModalParams.surveyData.plans_engineer_email" :rules="rules" single-line solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg3>
                <label class="blackLabel">Addition / Extension to be Covered</label>
                <v-text-field placeholder="Addition / Extension to be Covered" v-model="globalModalParams.surveyData.roof_extension_covered" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Additions Truss Type</label>
                <v-text-field placeholder="Additions Truss Type" v-model="globalModalParams.surveyData.roof_additions_truss_type" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Area of Exposed Trusses</label>
                <v-text-field placeholder="Area of Exposed Trusses" v-model="globalModalParams.surveyData.roof_area_trusses" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Exposed Truss Type</label>
                <v-text-field placeholder="Exposed Truss Type" v-model="globalModalParams.surveyData.roof_expose_truss_type" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg12>
                <label class="blackLabel">Other Notes</label>
                <v-text-field placeholder="Other Notes" v-model="globalModalParams.surveyData.roof_other_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg12 class="formDivider"></v-flex>
              <v-flex lg12>
                <h4>SUNDRIES FOR QUOTE</h4>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Roof Pitch</label>
                <v-text-field placeholder="Roof Pitch" v-model="globalModalParams.surveyData.roof_sundries_roof_pitch" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Overhang Length</label>
                <v-text-field placeholder="Overhang Length" v-model="globalModalParams.surveyData.roof_sundries_overhang_length" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Fascia Type</label>
                <v-text-field placeholder="Fascia Type" v-model="globalModalParams.surveyData.roof_sundries_fascia_type" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Barge Type</label>
                <v-text-field placeholder="Barge Type" v-model="globalModalParams.surveyData.roof_sundries_barge_type" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Underlay Type</label>
                <v-text-field placeholder="Underlay Type" v-model="globalModalParams.surveyData.roof_sundries_underlay_type" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Other</label>
                <v-text-field placeholder="Other" v-model="globalModalParams.surveyData.roof_sundries_other" :rules="rules" single-line solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="7">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg12>
                <h4>ROOF SHEETING</h4>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Profile</label>
                <v-text-field placeholder="Profile" v-model="globalModalParams.surveyData.roof_sheeting_profile" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Material</label>
                <v-text-field placeholder="Material" v-model="globalModalParams.surveyData.roof_sheeting_material" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Thickness</label>
                <v-text-field placeholder="Thickness" v-model="globalModalParams.surveyData.roof_sheeting_thickness" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Colour</label>
                <v-text-field placeholder="Colour" v-model="globalModalParams.surveyData.roof_sheeting_colour" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg12 class="formDivider"></v-flex>
              <v-flex lg12>
                <h4>ROOF TILES</h4>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Profile</label>
                <v-text-field placeholder="Profile" v-model="globalModalParams.surveyData.roof_tiles_profile" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Colour & Pattern</label>
                <v-text-field placeholder="Colour & Pattern" v-model="globalModalParams.surveyData.roof_tiles_colour" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Ridge Type</label>
                <v-text-field placeholder="Ridge Type" v-model="globalModalParams.surveyData.roof_tiles_ridge_type" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Hip Starter</label>
                <v-text-field placeholder="Hip Starter" v-model="globalModalParams.surveyData.roof_tiles_hip_starter" :rules="rules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg12 class="formDivider"></v-flex>
              <v-flex lg12>
                <h4>OTHER</h4>
              </v-flex>
              <v-flex lg6>
                <label class="blackLabel">Other Covering Notes</label>
                <v-text-field placeholder="Other Covering Notes" v-model="globalModalParams.surveyData.roof_other_covering_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Ceilings and Brandering</label>
                <v-switch v-model="globalModalParams.surveyData.roof_other_ceilings_brandings"></v-switch>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Geyser / Platform</label>
                <v-switch v-model="globalModalParams.surveyData.roof_other_geyser_platform"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="8">
          <v-container grid-list-xl class="fullContainerSub">
            <v-layout row wrap>
              <v-flex lg12>
                <h4>PUBLIC BUILDING</h4>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Geysers</label>
                <v-select :items="geysers" placeholder="" v-model="globalModalParams.surveyData.design_assistance_geysers" :rules="rules" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Windloads</label>
                <v-select :items="windloads" placeholder="" v-model="globalModalParams.surveyData.design_assistance_windloads" :rules="rules" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg3>
                <label class="blackLabel">Attic / Storage Loads</label>
                <v-select :items="loads" placeholder="" v-model="globalModalParams.surveyData.design_assistance_attic_storage" :rules="rules" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
              </v-flex>
              <v-flex lg12 class="formDivider"></v-flex>
              <v-flex lg12>
                <h4>INSTALLATION NOTES</h4>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">Supply Only Notes</label>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">Trusses & Braces Only Notes</label>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">Trusses, Bracing & Sundries Only Notes</label>
              </v-flex>
              <v-flex lg1>
                <v-switch v-model="globalModalParams.surveyData.install_notes_supply"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-text-field placeholder="Supply Only Notes" v-model="globalModalParams.surveyData.install_notes_supply_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-switch v-model="globalModalParams.surveyData.install_notes_trusses_braces"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-text-field placeholder="Trusses & Braces only Notes" v-model="globalModalParams.surveyData.install_notes_trusses_braces_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-switch v-model="globalModalParams.surveyData.install_notes_trusses_braces_sundries"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-text-field placeholder="Trusses, Bracing & Sundries Only Notes" v-model="globalModalParams.surveyData.install_notes_trusses_braces_sundries_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">Special Waterproofing Required Notes</label>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">A19 Inspectorate Certificate Notes</label>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">Trusses, Bracing, Sundries & Covering Complete Notes</label>
              </v-flex>
              <v-flex lg1>
                <v-switch v-model="globalModalParams.surveyData.install_notes_special_waterproofing"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-text-field placeholder="Special Waterproofing Required Notes" v-model="globalModalParams.surveyData.install_notes_special_waterproofing_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-switch v-model="globalModalParams.surveyData.install_notes_certificate"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-text-field placeholder="A19 Inspectorate Certificate Notes" v-model="globalModalParams.surveyData.install_notes_certificate_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-switch v-model="globalModalParams.surveyData.install_notes_trusses_braces_sundries_covering"></v-switch>
              </v-flex>
              <v-flex lg3>
                <v-text-field placeholder="Trusses, Bracing, Sundries & Covering Complete Notes" v-model="globalModalParams.surveyData.install_notes_trusses_braces_sundries_covering_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
              <v-flex lg12>
                <label class="blackLabel">Special Notes</label>
                <v-text-field placeholder="Special Notes" v-model="globalModalParams.surveyData.install_notes_special_notes" :rules="rules" multiple solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>-->
      </v-tabs>
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
          <v-btn color="success" class="text-xs-right" @click.stop="fncUpdateSurvey()">Save</v-btn>
          <!--<v-btn color="success" class="text-xs-right" @click.stop="fncConvertToCallout()">Convert to 'Measure To Quote' for callout payment</v-btn>-->
          <v-btn color="success" class="text-xs-right" @click.stop="fncConvertToCallout()" v-if="convertLoading == false && ( globalModalParams.surveyData.survey_type == 1 || globalModalParams.surveyData.survey_type == 2 )">Convert to 'Measure To Quote' for callout payment</v-btn>
          <v-progress-circular indeterminate :width="3" :size="20" v-if="convertLoading == true" color="white" class="pt-3 loginLoader"></v-progress-circular>
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				objUser: 0,
        rules: [
          v => !!v || 'Required Field',
        ],
        geysers: [
          { id: '200l Geyser', name: '200l Geyser' },
          { id: '300l Geyser', name: '300l Geyser' },
          { id: '> 300l Geyser', name: '> 300l Geyser' }
        ],
        windloads: [
          { id: 'Cat 1: Fully Exposed', name: 'Cat 1: Fully Exposed' },
          { id: 'Cat 2: Semi Exposed', name: 'Cat 2: Semi Exposed' },
          { id: '> Cat 3: Densely Populated ', name: 'Cat 3: Densely Populated ' }
        ],
        loads: [
          { id: 'None', name: 'None' },
          { id: 'Air Conditioners', name: 'Air Conditioners' },
          { id: 'Attic Storage', name: 'Attic Storage' },
          { id: 'Solar Geysers', name: 'Solar Geysers' },
          { id: 'Attic Domestic', name: 'Attic Domestic' },
          { id: 'Exceptions (Snow / Wind)', name: 'Exceptions (Snow / Wind)' }
        ],
        headers: [
          { text: 'File', value: 'description', width: '90%' },
          { text: 'Remove', value: 'description', width: '10%' },
        ],
        buildingTypes: [
          { id: 'New', name: 'New' },
          { id: 'Extension', name: 'Extension' },
          { id: 'Renovation', name: 'Renovation' },
          { id: 'Public Building', name: 'Public Building' },
          { id: 'Other', name: 'Other' }
        ],
        buildingStages: [
          { id: 'Tender', name: 'Tender' },
          { id: 'Window Height', name: 'Window Height' },
          { id: 'Not Started', name: 'Not Started' },
          { id: 'Ground Floor', name: 'Ground Floor' },
          { id: 'Foundation', name: 'Foundation' },
          { id: 'Wall Plate', name: 'Wall Plate' }
        ],
        access: [
          { id: 'Easy', name: 'Easy' },
          { id: 'Narrow Roads', name: 'Narrow Roads' },
          { id: 'Truck Only', name: 'Truck Only' },
          { id: 'Steep Slope', name: 'Steep Slope' },
          { id: 'Trailer', name: 'Trailer' },
          { id: 'Permit', name: 'Permit' }
        ],
        processData: []
			};
		},
		methods: {
      fncConvertToCallout() {
        this.$store.dispatch('fncUpdateSurveyDocumentType', this.globalModalParams.surveyData.quote);
        this.$store.commit('setConvertLoading', true);
      },
      fncCheckClass( type ) {
        return type;
      },
      fncUpdateSurvey() {
        this.globalModalParams.surveyData.process_data = this.processData;
        this.$store.dispatch('fncUpdateSurveyDocument', this.globalModalParams.surveyData);
      },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
      fncCheckValid() {

        this.surveyValid = true;
        if( this.storeInfoBranch != '' && this.clientInfoCoName != '' && this.clientInfoContact != '' && this.clientInfoEmail != '' ) {
          this.surveyValid = false;
        }
        for( var t in this.processData.tabs ) {
          for( var f in this.processData.tabs[t].form ) {
            if( this.processData.tabs[t].form[f].required == 'true' && this.processData.tabs[t].form[f].value == '' ) {
              this.surveyValid = true;
            }
          }
        }
      },
      fncGetValues( valueData ) {
        return valueData.split(',');
      }
		},
    beforeMount() {
      this.$store.dispatch('fncRetrieveKams');
      this.$store.dispatch('fncPopulateBranches');
      this.$store.dispatch('fncPopulateProjectList');
    },
    mounted() {
	    this.globalModalParams.surveyData.store_info_branch = parseInt( this.globalModalParams.surveyData.store_info_branch );
	    this.processData = JSON.parse(this.globalModalParams.surveyData.process_data);
	    for( var p in this.processData.tabs ) {
        for( var f in this.processData.tabs[p].form ) {
          if( this.processData.tabs[p].form[f].type == 'yesno' ) {
            var boolCheck = ( this.processData.tabs[p].form[f].value == 'true' );
            this.processData.tabs[p].form[f].value = boolCheck;
          }
        }
      }
      this.$store.commit('setConvertLoading', false);
    },
    watch: {
      kamUsers() {
        this.globalModalParams.surveyData.store_info_kam = parseInt( this.globalModalParams.surveyData.store_info_kam );
      }
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
        'kamUsers',
        'branchList',
        'projectList',
        'convertLoading'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
